export default __webpack_public_path__ + "static/media/logo22.c60a9732.png";